import React from 'react';
import { DiscountKind } from '../../types/api';
import { useLanguage } from '../../contexts/LanguageContext';
import { FormCard } from '../form/FormShell';
import { Field, FieldGrid } from '../form/Field';

interface DiscountMainCardProps {
  name: string;
  kind: DiscountKind;
  nameError?: string;
  disabled: boolean;
  onNameChange: (name: string) => void;
  onKindChange: (kind: DiscountKind) => void;
}

/** Предел длины имени — как правило `max:255` на бэке. */
const NAME_MAX_LENGTH = 255;

/**
 * Первая карточка: имя и вид. Имя идёт первым — по нему партнёр узнаёт
 * акцию в списке, а гость — в приложении («Кальян + чай до 18:00»).
 */
export function DiscountMainCard({
  name,
  kind,
  nameError,
  disabled,
  onNameChange,
  onKindChange,
}: DiscountMainCardProps) {
  const { t } = useLanguage();
  const strings = t.discounts;

  const kinds: Array<{ value: DiscountKind; title: string; hint: string; glyph: string }> = [
    { value: 'group', title: strings.kindGroup, hint: strings.kindGroupHint, glyph: '−%' },
    { value: 'combo', title: strings.kindCombo, hint: strings.kindComboHint, glyph: '1+1' },
  ];

  return (
    <FormCard title={strings.cardMain} hint={strings.cardMainHint}>
      <FieldGrid>
        <Field label={strings.name} wide htmlFor="discount-name" error={nameError} hint={strings.nameHint}>
          <input
            id="discount-name"
            type="text"
            value={name}
            onChange={(event) => onNameChange(event.target.value)}
            className="qp-control"
            placeholder={strings.namePlaceholder}
            maxLength={NAME_MAX_LENGTH}
            disabled={disabled}
          />
        </Field>

        <div className="qp-field qp-field--wide">
          <span className="qp-field-label" id="discount-kind-label">
            {strings.kind}
          </span>
          <div className="qp-kind" role="group" aria-labelledby="discount-kind-label">
            {kinds.map((option) => (
              <button
                key={option.value}
                type="button"
                className="qp-kind-opt"
                aria-pressed={kind === option.value}
                aria-label={option.title}
                aria-describedby={`discount-kind-${option.value}`}
                onClick={() => onKindChange(option.value)}
                disabled={disabled}
              >
                <span className="qp-kind-glyph" aria-hidden>
                  {option.glyph}
                </span>
                <span className="qp-kind-body">
                  <span className="qp-kind-title">{option.title}</span>
                  <span className="qp-kind-desc" id={`discount-kind-${option.value}`}>
                    {option.hint}
                  </span>
                </span>
              </button>
            ))}
          </div>
        </div>
      </FieldGrid>
    </FormCard>
  );
}
